import type * as Types from '../../../../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUnfinishedMediaplansQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUnfinishedMediaplansQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly unfinishedMediaplans: ReadonlyArray<{ readonly __typename?: 'AccountsMediaplan', readonly id: string, readonly startOn: string, readonly endOn?: string | null, readonly type: Types.AccountsMediaplanType, readonly repeat?: Types.AccountsMediaplanRepeat | null, readonly startOnPeriodBegin?: boolean | null, readonly budget: number, readonly kpis?: ReadonlyArray<{ readonly __typename?: 'AccountsKpi', readonly primary: boolean, readonly name: Types.AccountsKpiName, readonly value: string | number }> | null }> } | null } | null };

export type GetGraphStatsQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetGraphStatsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly graphStats: ReadonlyArray<{ readonly __typename?: 'YalperGraphStat', readonly currency: string, readonly date: string, readonly spent: number, readonly extendedPlatform: Types.YalperExtendedPlatform, readonly platform: Types.YalperPlatform }> } | null } | null };


export const GetUnfinishedMediaplansDocument = gql`
    query GetUnfinishedMediaplans {
  currentUser {
    currentCompany {
      unfinishedMediaplans {
        id
        startOn
        endOn
        type
        repeat
        startOnPeriodBegin
        budget
        kpis {
          primary
          name
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetUnfinishedMediaplansQuery__
 *
 * To run a query within a React component, call `useGetUnfinishedMediaplansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnfinishedMediaplansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnfinishedMediaplansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnfinishedMediaplansQuery(baseOptions?: Apollo.QueryHookOptions<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>(GetUnfinishedMediaplansDocument, options);
      }
export function useGetUnfinishedMediaplansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>(GetUnfinishedMediaplansDocument, options);
        }
export function useGetUnfinishedMediaplansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>(GetUnfinishedMediaplansDocument, options);
        }
export type GetUnfinishedMediaplansQueryHookResult = ReturnType<typeof useGetUnfinishedMediaplansQuery>;
export type GetUnfinishedMediaplansLazyQueryHookResult = ReturnType<typeof useGetUnfinishedMediaplansLazyQuery>;
export type GetUnfinishedMediaplansSuspenseQueryHookResult = ReturnType<typeof useGetUnfinishedMediaplansSuspenseQuery>;
export type GetUnfinishedMediaplansQueryResult = Apollo.QueryResult<GetUnfinishedMediaplansQueryPage, GetUnfinishedMediaplansQueryVariables>;
export const GetGraphStatsDocument = gql`
    query GetGraphStats($startDate: Date!, $endDate: Date!) {
  currentUser {
    currentCompany {
      graphStats(startDate: $startDate, endDate: $endDate) {
        currency
        date
        spent
        extendedPlatform
        platform
      }
    }
  }
}
    `;

/**
 * __useGetGraphStatsQuery__
 *
 * To run a query within a React component, call `useGetGraphStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphStatsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetGraphStatsQuery(baseOptions: Apollo.QueryHookOptions<GetGraphStatsQueryPage, GetGraphStatsQueryVariables> & ({ variables: GetGraphStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphStatsQueryPage, GetGraphStatsQueryVariables>(GetGraphStatsDocument, options);
      }
export function useGetGraphStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphStatsQueryPage, GetGraphStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphStatsQueryPage, GetGraphStatsQueryVariables>(GetGraphStatsDocument, options);
        }
export function useGetGraphStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphStatsQueryPage, GetGraphStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGraphStatsQueryPage, GetGraphStatsQueryVariables>(GetGraphStatsDocument, options);
        }
export type GetGraphStatsQueryHookResult = ReturnType<typeof useGetGraphStatsQuery>;
export type GetGraphStatsLazyQueryHookResult = ReturnType<typeof useGetGraphStatsLazyQuery>;
export type GetGraphStatsSuspenseQueryHookResult = ReturnType<typeof useGetGraphStatsSuspenseQuery>;
export type GetGraphStatsQueryResult = Apollo.QueryResult<GetGraphStatsQueryPage, GetGraphStatsQueryVariables>;